/*
 *
 * Script for font size accessibility features
 *
 */

import { setCookie, getCookie, deleteCookie } from './cookies';

export const fontSizeAccessibility = () => {
    const fontSizeIncreaseButtons = document.querySelectorAll('.button-font-size-increase');
    const fontSizeDecreaseButtons = document.querySelectorAll('.button-font-size-decrease');

    const defaultFontSize = 10;
    const minFontSize = 8;
    const maxFontSize = 15;

    const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

    const getFontSize = () => {
        const storedSize = getCookie('fontsize');
        const parsed = storedSize ? parseInt(storedSize, 10) : NaN;

        if (Number.isNaN(parsed)) return defaultFontSize;

        return clamp(parsed, minFontSize, maxFontSize);
    };

    const applyFontSizeToDOM = (size) => {
        if (size === defaultFontSize) {
            document.documentElement.style.removeProperty('--font-size');
        } else {
            document.documentElement.style.setProperty('--font-size', `${size}px`);
        }
    };

    const updateButtonClasses = () => {
        const fontSize = getFontSize();

        fontSizeIncreaseButtons.forEach(button => {
            button.classList.toggle('--active', fontSize > defaultFontSize);
        });

        fontSizeDecreaseButtons.forEach(button => {
            button.classList.toggle('--active', fontSize < defaultFontSize);
        });
    };

    const updateFontSize = (newSize) => {
        const size = clamp(newSize, minFontSize, maxFontSize);

        if (size === defaultFontSize) {
            deleteCookie('fontsize');
        } else {
            setCookie('fontsize', String(size), 7);
        }

        applyFontSizeToDOM(size);
        updateButtonClasses();
    };

    // initial load
    const currentSize = getFontSize();
    applyFontSizeToDOM(currentSize);
    updateButtonClasses();

    const setupButtonListeners = (buttons, change, boundKey) => {
        buttons.forEach(button => {
            // Prevent binding twice if init runs twice
            if (button.dataset[boundKey] === 'true') return;
            button.dataset[boundKey] = 'true';

            button.addEventListener('click', (e) => {
                e.preventDefault();

                const fontSize = getFontSize();
                updateFontSize(fontSize + change);
            });
        });
    };

    setupButtonListeners(fontSizeIncreaseButtons, 1, 'fontSizeIncreaseBound');
    setupButtonListeners(fontSizeDecreaseButtons, -1, 'fontSizeDecreaseBound');
};